<app-header></app-header>
<app-verticalnav [isOpen]="(isSidebarOpen$ | async) ?? false"></app-verticalnav>
<div class="app-content-wrapper">
  <router-outlet></router-outlet>
</div>
